<template>
  <index></index>
</template>


<script>
  import Index from './IndexMain'
  export default {
    name: 'userCenter',
    components: {
      Index
    }
  }
</script>



// WEBPACK FOOTER //
// Index.vue?15d4dc34